import React, {useEffect} from 'react';

export default function GivingEmbed(props) {
  useEffect(() => {
    if($("#sk-giving-script").length === 0) {
      $('head').append("<script type=\"module\" id=\"sk-giving-script\" src=\"https://embedded-apps.servantkeeper.com/sk-giving-app.js\"></script>");
    }
  }, []);

  const formId = props.section.prop('sk_form_id');

  return <sk-giving-app web-id={FW.store.get('customer').get('sk_web_id')} form-id={formId}/>
}
